import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { PublicLayout, AppLayout, ProtectedRoute } from "@/components/Layout";
import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import CountryPage from "@/pages/CountryPage";
import Pricing from "@/pages/Pricing";
import { About, FAQ, Contact, Legal } from "@/pages/StaticPages";
import SeoPage from "@/pages/SeoPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/AuthPages";
import Onboarding from "@/pages/Onboarding";
import Assessment from "@/pages/Assessment";
import Dashboard from "@/pages/Dashboard";
import { LessonsList, LessonDetail } from "@/pages/Learning";
import { MissionsList, MissionDetail } from "@/pages/Missions";
import Mistakes from "@/pages/Mistakes";
import Drills from "@/pages/Drills";
import Progress from "@/pages/Progress";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/country/:code" element={<CountryPage />} />
            <Route path="/english-for-migrants/:country" element={<SeoPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:kind" element={<Legal />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Route>

          {/* Auth (no layout) */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Onboarding & assessment (auth required, no strict onboarding gate) */}
          <Route path="/onboarding" element={
            <ProtectedRoute requireOnboarding={false}><Onboarding/></ProtectedRoute>
          } />
          <Route path="/assessment" element={
            <ProtectedRoute><Assessment/></ProtectedRoute>
          } />

          {/* Authenticated app */}
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/learn" element={<LessonsList />} />
            <Route path="/learn/:lessonId" element={<LessonDetail />} />
            <Route path="/missions" element={<MissionsList />} />
            <Route path="/missions/:scenarioId" element={<MissionDetail />} />
            <Route path="/mistakes" element={<Mistakes />} />
            <Route path="/drills" element={<Drills />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/profile" element={<Profile />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/*" element={
            <ProtectedRoute adminOnly requireOnboarding={false}><Admin/></ProtectedRoute>
          }/>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
